export enum QR_TYPES {
  APP = "app",
  BITCOIN = "bitcoin",
  BUSINESSPAGE = "businesspage",
  CALL = "call",
  COUPON = "coupon",
  EMAIL = "email",
  EVENT = "event",
  FACEBOOK = "facebook",
  FEEDBACK = "feedback",
  IMAGES = "images",
  LINKEDIN = "linkedin",
  LOCATION = "location",
  MENU = "menu",
  MP3 = "mp3",
  PDF = "pdf",
  RATING = "rating",
  SMS = "sms",
  SOCIALMEDIA = "socialmedia",
  TEXT = "text",
  URL = "url",
  VCARD = "vcard",
  VIDEO = "video",
  WIFI = "wifi",
}
